<ng-template #noItemsElement>
  @if (productsToSelect().length || missingProducts().length) {
    <ng-container *ngTemplateOutlet="quickOrderProductSelection"></ng-container>
  } @else {
    <ui-quick-order-initial (tabSelected)="tabSelected.emit($event)"></ui-quick-order-initial>
  }
</ng-template>

<div class="wrapper-quick-order-list">
  @if (isLoading()) {

  } @else if (error()) {
    <ui-alert
      theme="error"
      message="Es ist ein Fehler beim Laden der Schnellerfassungsliste aufgetreten. Bitte versuchen Sie es erneut.">
    </ui-alert>
  } @else {
    <ui-shopping-list-items
      [items]="items()"
      (itemQuantityChanged)="onItemQuantityChanged($event)"
      (itemsRemoved)="onRemoveItems($event)"
      (itemsAddToCart)="onItemsAddToCart($event)"
      (download)="download()"
      [noItemsElement]="noItemsElement"
      [isDownloading]=isDownloading()
    >
      <ng-container *ngTemplateOutlet="quickOrderProductSelection"></ng-container>
    </ui-shopping-list-items>
  }
</div>

<ng-template #quickOrderProductSelection>
  <div class="product-selection">
    @if (missingProducts().length) {
      <ui-alert [message]="missingProductsAlertMessage()" theme="info"></ui-alert>
    }
    @if (productsToSelect().length) {
      <ui-quick-order-product-selection (productsToSelectChange)="productsToSelect.set($event)" [productsToSelect]="productsToSelect()" (productsSelected)="onItemsSelected($event)"></ui-quick-order-product-selection>
    }
  </div>
</ng-template>
